"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorName = exports.Color = void 0;
var Color;
(function (Color) {
    Color[Color["Black"] = 0] = "Black";
    Color[Color["LowBlue"] = 1] = "LowBlue";
    Color[Color["LowGreen"] = 2] = "LowGreen";
    Color[Color["LowCyan"] = 3] = "LowCyan";
    Color[Color["LowRed"] = 4] = "LowRed";
    Color[Color["LowMagenta"] = 5] = "LowMagenta";
    Color[Color["Brown"] = 6] = "Brown";
    Color[Color["LightGray"] = 7] = "LightGray";
    Color[Color["DarkGray"] = 8] = "DarkGray";
    Color[Color["HighBlue"] = 9] = "HighBlue";
    Color[Color["HighGreen"] = 10] = "HighGreen";
    Color[Color["HighCyan"] = 11] = "HighCyan";
    Color[Color["HighRed"] = 12] = "HighRed";
    Color[Color["HighMagenta"] = 13] = "HighMagenta";
    Color[Color["Yellow"] = 14] = "Yellow";
    Color[Color["White"] = 15] = "White";
})(Color || (exports.Color = Color = {}));
var ColorName;
(function (ColorName) {
    ColorName["Black"] = "Black";
    ColorName["LowBlue"] = "Low Blue";
    ColorName["LowGreen"] = "Low Green";
    ColorName["LowCyan"] = "Low Cyan";
    ColorName["LowRed"] = "Low Red";
    ColorName["LowMagenta"] = "Low Magenta";
    ColorName["Brown"] = "Brown";
    ColorName["LightGray"] = "Light Gray";
    ColorName["DarkGray"] = "Dark Gray";
    ColorName["HighBlue"] = "High Blue";
    ColorName["HighGreen"] = "High Green";
    ColorName["HighCyan"] = "High Cyan";
    ColorName["HighRed"] = "High Red";
    ColorName["HighMagenta"] = "High Magenta";
    ColorName["Yellow"] = "Yellow";
    ColorName["White"] = "White";
})(ColorName || (exports.ColorName = ColorName = {}));
//# sourceMappingURL=Color.js.map